;(function(){
  var store = {},
      win = window,
      doc = win.document,
      localStorageName = 'localStorage',
      namespace = '__storejs__'

  var storage = win[localStorageName]
  store.disabled = false
  store.set = function(key, value) {}
  store.get = function(key) {}
  store.remove = function(key) {}
  store.clear = function() {}

  store.transact = function(key, defaultVal, transactionFn) {
    var val = store.get(key)
    if (transactionFn == null) {
      transactionFn = defaultVal
      defaultVal = null
    }
    if (typeof val == 'undefined') { val = defaultVal || {} }
    transactionFn(val)
    store.set(key, val)
  }

  store.getAll = function() {}

  store.serialize = function(value, b64) {
    value = JSON.stringify(value);
    return b64 ? btoa(value) : value;
  }

  store.deserialize = function(value, b64) {
    if (typeof value != 'string') { return undefined }
    try {
      if (b64) { value = atob(value) }
      return JSON.parse(value);
    } catch(e) { return value || undefined }
  }

  store.set = function(key, val, b64) {
    b64 = typeof b64 === 'undefined' ? false : b64;
    if (val === undefined) { return store.remove(key) }
    storage.setItem(key, store.serialize(val, b64))
    return val
  }

  store.get = function(key, b64) {
    b64 = typeof b64 === 'undefined' ? false : b64;
    return store.deserialize(storage.getItem(key), b64);
  }

  store.remove = function(key) { storage.removeItem(key) }

  store.clear = function() { storage.clear() }

  store.getAll = function() {
    var ret = {}
    for (var i=0; i<storage.length; ++i) {
      var key = storage.key(i)
      ret[key] = store.get(key)
    }
    return ret
  }

  try {
    store.set(namespace, namespace)
    if (store.get(namespace) != namespace) { store.disabled = true }
    store.remove(namespace)
  } catch(e) {
    store.disabled = true
  }
  store.enabled = !store.disabled
  if (typeof module != 'undefined' && module.exports) { module.exports = store }
  else if (typeof define === 'function' && define.amd) { define(store) }
  else { window.store = store }
})();
